import { Translate } from '@/components';
import styles from './Headline.styles';

interface Props {
  children: React.ReactNode;
  dataTestId?: string;
}
export const Headline: React.FC<Props> = ({ children, dataTestId }) => (
  <h1 className={styles.container} data-testid={dataTestId}>
    <Translate>{children}</Translate>
  </h1>
);
